import gql from "graphql-tag";

import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {districtIdType} from "./__graphql-types__/index.ts";

export const DISTRICT_ID_QUERY: GqlOperation<
    districtIdType["response"],
    districtIdType["variables"]
> = gqlOp(gql`
    query districtId {
        user {
            id
            userDistrictInfos {
                id
                district {
                    id
                }
            }
        }
    }
`);

export const useDistrictId = () => {
    const [districtIdResult] = useQuery(DISTRICT_ID_QUERY);
    const districtId =
        districtIdResult.status === "success"
            ? (districtIdResult.data?.user?.userDistrictInfos?.[0]?.district
                  ?.id ?? null)
            : null;

    return districtId;
};
